// extracted by mini-css-extract-plugin
export default {"login_btn":"login_login_btn__Etyh3","heading":"login_heading__CEGgY"};